import JobIcon from '@mui/icons-material/Task';
import JobList from './JobList';
import JobEdit from './JobEdit';
import JobCreate from './JobCreate';

export default {
    list: JobList,
    edit: JobEdit,
    create: JobCreate,
    icon: JobIcon,
};
